import {remCalc} from '_themeUtils'
import productTileOverlay from './partials/overlay/overlay'
import sizeSelector from './partials/overlay/partials/size-selector'
import quickAddButton from './quick-add-button'

const productTileBase = {
    ProductTile: {
        baseStyle: (props) => {
            const isShopTheImage = props?.listingLayout === 'shoptheimage'
            return {
                wrapper: {
                    pos: 'relative',
                    w: '100%',
                },
                imageWrapper: {
                    pos: 'relative',
                },
                image: isShopTheImage ? {pointerEvents: {base: 'none', md: 'auto'}} : {},
                skeletonImageWrapper: {
                    pos: 'relative',
                    pt: '127.3%',
                },
                skeletonImage: {
                    pos: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: 'none',
                },
                hoverImage: {
                    pos: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 1,
                    opacity: 0,
                    transition: 'opacity 0.2s ease-in-out',
                    _hover: {
                        opacity: 1,
                    },
                },
                tagLabel: {
                    position: 'absolute',
                    zIndex: 'docked',
                    top: {base: 'spacing.2', lg: 'spacing.4'},
                    left: {base: 'spacing.2', lg: 'spacing.4'},
                },
                favouriteButton: {
                    position: 'absolute',
                    zIndex: 'docked',
                    top: {base: 'spacing.2', lg: 'spacing.4'},
                    right: {base: 'spacing.2', lg: 'spacing.4'},
                },
                body: {
                    w: '100%',
                    alignItems: 'flex-start',
                    pt: 'space.padding.vertical.md',
                },
                horizontalBody: {
                    px: 'spacing.4',
                },
                details: {
                    w: '100%',
                    alignItems: 'flex-start',
                    mr: 'auto',
                    gap: 0,
                    letterSpacing: remCalc(1.14),
                    pl: {base: 'spacing.4', sm: '0'},
                },
                skeletonTitle: {
                    borderRadius: 'none',
                    w: '60%',
                    height: '20px',
                },
                skeletonPrice: {
                    borderRadius: 'none',
                    w: '40%',
                    height: '17px',
                },
                name: {
                    textStyle: 'paragraphMd',
                    fontWeight: 400,
                    mb: 'spacing.1.5',
                },
                colorsAvailability: {
                    textStyle: 'paragraphXxs',
                    color: 'color.text.grey.600',
                    letterSpacing: remCalc(2.5),
                    mt: 'spacing.1',
                },
                productSetTitle: {
                    textStyle: 'paragraphMd',
                    fontWeight: 400,
                    borderBottom: '1px solid',
                    borderColor: 'color.border.black',
                },

                carouselSlideContainer: {
                    position: 'relative',
                    w: '100%',
                    '.swiper': {
                        w: '100%',

                        '.swiper-scrollbar': {
                            left: 0,
                            bottom: 0,
                            width: '100%',
                            height: remCalc(2),

                            '.swiper-scrollbar-drag': {
                                borderRadius: 0,
                                bg: 'color.border.black',
                            },
                        },

                        '.swiper-slide-active': {
                            w: '100% !important',
                        },
                    },

                    '.productTile__image-hover-fade': {
                        position: 'absolute',
                        zIndex: 'docked',
                        visibility: 'visible',
                        opacity: 1,
                        transition: 'opacity 250ms linear',

                        '&.invisible': {
                            visibility: 'hidden',
                            opacity: 0,
                            transition: 'visibility 0s 250ms, opacity 250ms linear',
                        },

                        '&.hidden': {
                            display: 'none',
                        },
                    },

                    _hover: {
                        '.swiper-button-prev, .swiper-button-next': {
                            visibility: 'visible',
                        },
                    },
                },
                navigationPrev: {
                    height: 'auto',
                    pos: 'absolute',
                    left: 0,
                    top: '50%',
                    mt: 0,
                    ml: 'spacing.2',
                    color: 'color.icon.black',
                    cursor: 'pointer',
                    zIndex: 2,
                    _after: {
                        display: 'none',
                    },
                },
                navigationNext: {
                    height: 'auto',
                    pos: 'absolute',
                    right: 0,
                    top: '50%',
                    mt: 0,
                    mr: 'spacing.2',
                    color: 'color.icon.black',
                    cursor: 'pointer',
                    zIndex: 2,
                    _after: {
                        display: 'none',
                    },
                },
            }
        },
    },
}

const productTile = {
    ...productTileBase,
    ...sizeSelector,
    ...productTileOverlay,
    ...quickAddButton,
}

export default productTile
